import type { ReactNode } from "react";
import React from "react";

type WithKeysInputProps = {
    onEnter?(event: KeyboardEvent): void;
    onEscape?(event: KeyboardEvent): void;
    isEnterDisabled?: boolean;
    children: ReactNode;
};

export class WithKeysInput extends React.Component<WithKeysInputProps> {
    componentDidMount = () => {
        window.addEventListener("keyup", this.handleEvent);
    };

    componentWillUnmount = () => {
        window.removeEventListener("keyup", this.handleEvent);
    };

    handleEvent = (event: KeyboardEvent) => {
        if (event.key === "Enter" && !this.props.isEnterDisabled) {
            this.props.onEnter?.(event);
        }

        if (event.key === "Escape") {
            this.props.onEscape?.(event);
        }
    };

    render() {
        return this.props.children;
    }
}
